export const cardNumberPattern = (length: number): string => `^[0-9A-Za-z]{${length}}$`;

export const normalizeCardNumber = (value: string | null | undefined): string | null => {
  const trimmedValue = (value ?? "").trim();

  if (trimmedValue === "") {
    return null;
  }

  return trimmedValue;
};

export const isValidCardNumber = (value: string | null | undefined, length: number): boolean => {
  const normalizedValue = normalizeCardNumber(value);

  if (normalizedValue === null) {
    return true;
  }

  return new RegExp(cardNumberPattern(length)).test(normalizedValue);
};
